import { ReactNode } from 'react'
import { connect } from 'react-redux'

import BasePage, { CONNECTION_ERROR } from '../BasePage'

import { STEP_2_VALIDATION_URL } from '../../costants'

import Contractor from '../../components/people/contractor/Contractor'
import SiNo, { SiNoType, getBoolean, getSiNoValue } from '../../components/siNo/SiNo'
import { isValidPrivacy, getPrivacyForSubmit } from '../../components/privacy/BasicPrivacy'

import LoginRegister from '../../components/login/LoginRegister'
import CommonsPolicyFields from '../../components/commons/CommonsPolicyFields'
import NoMotorPrivacy from '../../components/privacy/NoMotorPrivacy'
import ModalFinalQuestion from '../../components/final/ModalFinalQuestion'

import TipoProfessionista, { getProfessionistaValue } from './TipoProfessionista'

import SinglePage from '../../components/pagination/SinglePage'
import Pagination from '../../components/pagination/Pagination'

import { authFetch } from '../../libs/cookie/Cookie'

import Input from '../../libs/ui/inputs/Input'
import MultipleCheckbox from '../../libs/ui/inputs/MultipleCheckbox'
import Select from '../../libs/ui/inputs/Select'
import ModalWaith from '../../libs/ui/modal/ModalWaith'
import ModalNotification from '../../libs/ui/modal/ModalNotification'

import { UserType } from '../../libs/user/User'
import { Person } from '../../libs/user/Person'
import * as StringValidation from '../../libs/validation/stringRegex'
import { objectsNamesValidation } from '../../libs/validation/remoteValidationAbstract'
import { isNotValidScadenzaPolizza } from '../../libs/validation/dateValidation'
import { CompleteValidationError } from '../../libs/validation/completeValidationError'

import { 
    getAreaProfessionale, getAreaGiuridica, getAreaMedica, getAreaTecnica, 
    getDirezioneSanitarie, getMassimali, getRegime, getRetroattivita, 
    getRisarcimenti, getAssicurazioni, getProfessionisti, getAltreAssicurazioni, 
    getAttivitaChirurgica,
    getProfessionByArea
} from '../../libs/initialization/remoteInits'

import { ProfessionalPageProps, ProfessionalPageState, profPageInitialState, profUpdate } from './ProfessionalPageSilce'

import { ZUKO_TRAK_ID } from '../../trak/zuko'

import { store } from '../../redux/store'

import '../../sass/App.scss'


class ProfessionalPage extends BasePage<ProfessionalPageProps, ProfessionalPageState> {
    constructor (props: any) {
        super(props)

        this.state = {
            ...profPageInitialState,
            ...props
        }

        // metodi ereditati
        this.getInitialState = this.getInitialState.bind(this)
        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)
        this.getRilevanzaForSubmit = this.getRilevanzaForSubmit.bind(this)
        this.getSpecificDataForSubmit = this.getSpecificDataForSubmit.bind(this)
        this.saveStateAndRedux = this.saveStateAndRedux.bind(this)

        // metodi specifici del preventivatore
        this.updateTipo_area_professionale = this.updateTipo_area_professionale.bind(this)
        this.updateTipo_area_giuridica = this.updateTipo_area_giuridica.bind(this)
        this.updateTipo_area_medica = this.updateTipo_area_medica.bind(this)
        this.updateTipo_area_tecnica = this.updateTipo_area_tecnica.bind(this)
        this.updateTipo_direzione_sanitarie = this.updateTipo_direzione_sanitarie.bind(this)
        this.updateTipo_massimali = this.updateTipo_massimali.bind(this)
        this.updateTipo_regime = this.updateTipo_regime.bind(this)
        this.updateTipo_retroattivita = this.updateTipo_retroattivita.bind(this)
        this.updateTipo_risarcimenti = this.updateTipo_risarcimenti.bind(this)
        this.updateTipo_assicurazioni = this.updateTipo_assicurazioni.bind(this)
        this.updateTipo_professionisti = this.updateTipo_professionisti.bind(this)
        this.updateTipo_altre_assicurazioni = this.updateTipo_altre_assicurazioni.bind(this)
        this.updateTipo_attivita_chirurgica = this.updateTipo_attivita_chirurgica.bind(this)

        this.updateSpecializzazione = this.updateSpecializzazione.bind(this)
        this.updateMassimale = this.updateMassimale.bind(this)
        this.updateTutela_legale = this.updateTutela_legale.bind(this)
        this.updateAltre_assicurazioni = this.updateAltre_assicurazioni.bind(this)
        this.updateRetroattivita = this.updateRetroattivita.bind(this)
        this.updateTipo_assicurazione = this.updateTipo_assicurazione.bind(this)
        this.updateDettaglio_attivita = this.updateDettaglio_attivita.bind(this)
        this.updateRinnovo = this.updateRinnovo.bind(this)
        this.updateRegime_medico = this.updateRegime_medico.bind(this)
        this.updateRisarcimenti = this.updateRisarcimenti.bind(this)
        this.updateDirezione_sanitaria = this.updateDirezione_sanitaria.bind(this)
        this.updateAttivita_chirurgica = this.updateAttivita_chirurgica.bind(this)
        this.updateSingolo = this.updateSingolo.bind(this)
        this.updateFatturato_precedente = this.updateFatturato_precedente.bind(this)
        this.updateFatturato_attuale = this.updateFatturato_attuale.bind(this)

        this.updateAreaProfessionale = this.updateAreaProfessionale.bind(this)
        this.updateProfessione = this.updateProfessione.bind(this)
        this.getApChanges = this.getApChanges.bind(this)
        this.getApProfessions = this.getApProfessions.bind(this)

        this.isValidDettaglio_attivita = this.isValidDettaglio_attivita.bind(this)
        this.step1ValidationNoProf = this.step1ValidationNoProf.bind(this)
        this.step2Validation = this.step2Validation.bind(this)

        this.clearContractorProfessionError = this.clearContractorProfessionError.bind(this)
    }

    componentDidMount(): void {
        super.componentDidMount()
        
        const Zuko = window.Zuko

        if (Zuko && ZUKO_TRAK_ID) {
            Zuko.trackForm( {target: document.body, slug: ZUKO_TRAK_ID} ).trackEvent(Zuko.FORM_VIEW_EVENT)
        }

        if (this.state.tipo_area_professionale === undefined) {
            getAreaProfessionale (this.updateTipo_area_professionale, this.manageExpiredSessions)
        }
        if (this.state.tipo_area_giuridica === undefined) {
            getAreaGiuridica (this.updateTipo_area_giuridica, this.manageExpiredSessions)
        }
        if (this.state.tipo_area_medica === undefined) {
            getAreaMedica (this.updateTipo_area_medica, this.manageExpiredSessions)
        }
        if (this.state.tipo_area_tecnica === undefined) {
            getAreaTecnica (this.updateTipo_area_tecnica, this.manageExpiredSessions)
        }
        if (this.state.tipo_direzione_sanitarie === undefined) {
            getDirezioneSanitarie (this.updateTipo_direzione_sanitarie, this.manageExpiredSessions)
        }
        
        if (this.state.tipo_regime === undefined) {
            getRegime (this.updateTipo_regime, this.manageExpiredSessions)
        }
        if (this.state.tipo_risarcimenti === undefined) {
            getRisarcimenti (this.updateTipo_risarcimenti, this.manageExpiredSessions)
        }
        if (this.state.tipo_assicurazioni === undefined) {
            getAssicurazioni (this.updateTipo_assicurazioni, this.manageExpiredSessions)
        }
        if (this.state.tipo_professionisti === undefined) {
            getProfessionisti (this.updateTipo_professionisti, this.manageExpiredSessions)
        }
        if (this.state.tipo_altre_assicurazioni === undefined) {
            getAltreAssicurazioni (this.updateTipo_altre_assicurazioni, this.manageExpiredSessions)
        }
        if (this.state.tipo_attivita_chirurgica === undefined) {
            getAttivitaChirurgica (this.updateTipo_attivita_chirurgica, this.manageExpiredSessions)
        }

        if (this.state.tipo_professioni === undefined && this.state.areaProfessionale !== undefined) {
            this.getApProfessions (this.state.areaProfessionale).then(
                (profs: any) => {
                    this.saveStateAndRedux({
                        tipo_professioni: profs?.professions ?? [],
                        professione: profs?.professions !== undefined ? this.state.professione : undefined
                    })
                }
            )
        }
    }

    componentDidUpdate( prevProps: Readonly<ProfessionalPageProps>, prevState: Readonly<ProfessionalPageState>, snapshot?: any ) : void {
        super.componentDidUpdate (prevProps, prevState, snapshot)

        if (
            (prevState.tipo_assicurazione === 'tutelaLegale' && this.state.tipo_assicurazione !== 'tutelaLegale') ||
            (this.state.tipo_assicurazione !== 'tutelaLegale' && prevState.altre_assicurazioni !== 'siRCPInfortuni' && this.state.altre_assicurazioni === 'siRCPInfortuni')
        ) {
            this.saveStateAndRedux({
                tutela_legale: undefined
            })
        }
        else if (prevState.tipo_assicurazione === 'rcProfessionale' && this.state.tipo_assicurazione !== 'rcProfessionale') {
            this.saveStateAndRedux({
                altre_assicurazioni: undefined
            })
        }

        // mi assicuro di rimuove gli errori relativi alla professione se ci sono
        if (
            this.state.user !== undefined &&
            prevState.user !== this.state.user
        ) {
            const mustFix = (this.state.user?.people ?? []).filter (
                (p: any) => ((p.errors ?? []).includes( 'Professione' ) === true)
            )

            if (mustFix.length > 0) {
                this.clearContractorProfessionError()
            }
        }
    }


    render () : ReactNode {
        const isLogged = this.state.expiredSessionError === false ? this.state.user !== undefined : false

        const erroOccours = this.state.globalError !== undefined

        const isMedico = this.state.areaProfessionale === 'medica'
        const isTecnico = this.state.areaProfessionale === 'tecnica'
        const isGiuridico = this.state.areaProfessionale === 'giuridicoCommerciale'

        return (
            <>
                <article className='container-fluid py-5'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-8'>

                            <header className='row'>
                                <form id="login_register_form" autoComplete='off'>
                                    <LoginRegister 
                                        isLogged={ isLogged } 
                                        isExpire={ this.state.expiredSessionError }
                                        showTitle={ true }
                                        loggedOkCallBack={ this.logUser }
                                        expiredSessionCallbak={ this.manageExpiredSessions }
                                    />
                                </form>
                            </header>

                            <form id="pets_form">
                                <Pagination
                                    maxPagges={2}
                                    actualPage={this.state.actualPage}
                                    updateActualPageCallBack={this.updateActualPage}
                                    manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                >
                                    <SinglePage
                                        show={this.state.actualPage === 1}
                                        pageNumber={1}
                                        isLast={false}
                                        validatePage={this.step1ValidationNoProf}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <Contractor 
                                            people={this.state.contractor}
                                            updatePeopleCallback={this.updateContractor}
                                            user={this.state.user}
                                            updateUserCallBack={ this.updateUser }
                                            expiredSessionCallbak={ this.manageExpiredSessions }
                                            error={this.state.contractorError}
                                            isOnlyFisica={false}
                                            isOnlyGiuridica={false}

                                            hideProfessione={true} // voglio far selezionare la professione in un secondo momento
                                        />
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 2}
                                        pageNumber={2}
                                        isLast={true}
                                        validatePage={this.step2Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                        sendCallBack={this.sendData}
                                    >
                                        <CommonsPolicyFields 
                                            rilevanza={ this.state.rilevanza }
                                            rilevanzaErrro={ this.state.rilevanzaError }
                                            updateRilevanza={ this.updateRilevanza }

                                            altriSinistri={this.state.altriSinistri}
                                            altriSinistriError={this.state.altriSinistriError}
                                            polizzaAttiva={this.state.polizzaAttiva}
                                            polizzaAttivaError={this.state.polizzaAttivaError}
                                            scadenzaPolizza={this.state.scadenzaPolizza}
                                            scadenzaPolizzaError={this.state.scadenzaPolizzaError}

                                            updateAltriSinistri={this.updateAltriSinistri}
                                            updatePloizzaAttiva={this.updatePloizzaAttiva}
                                            updateScadenzaPolizza={this.updateScadenzaPolizza}
                                        />

                                        <div className='col-12'>
                                            <Select
                                                id='area_professionale' name='area_professionale' key='area_professionale'
                                                label='Area Professionale' 
                                                value={this.state.areaProfessionale}
                                                options={this.state.tipo_area_professionale}
                                                callback={this.updateAreaProfessionale}
                                                error={this.state.areaProfessionaleError}
                                            />

                                            
                                            { this.state.areaProfessionale !== undefined && 
                                                this.state.tipo_professioni !== undefined && (this.state.tipo_professioni as Array<any>).length > 0 &&
                                                <>
                                                    { ! isMedico &&
                                                        <Select
                                                            id='professione' name='professione' key='area_professionale_professione'
                                                            label='Professione' 
                                                            value={this.state.professione}
                                                            options={this.state.tipo_professioni}
                                                            callback={this.updateProfessione}
                                                            error={this.state.professioneError}
                                                            onFocus={() => { this.setState({professioneError: undefined})}}
                                                        />
                                                    }

                                                    { isTecnico &&
                                                        <Select
                                                            id='specializzazione' name='specializzazione' key='specializzazione-tecnica'
                                                            label='Quale è la tua specializzazione?' 
                                                            value={this.state.specializzazione}
                                                            options={this.state.tipo_area_tecnica}
                                                            callback={this.updateSpecializzazione}
                                                            error={this.state.specializzazioneError}
                                                        />
                                                    }

                                                    { isGiuridico &&
                                                        <Select
                                                            id='specializzazione' name='specializzazione' key='specializzazione-giuridica'
                                                            label='Quale è la tua specializzazione?' 
                                                            value={this.state.specializzazione}
                                                            options={this.state.tipo_area_giuridica}
                                                            callback={this.updateSpecializzazione}
                                                            error={this.state.specializzazioneError}
                                                        />
                                                    }

                                                    { (isTecnico || isGiuridico) &&
                                                        <>
                                                            <TipoProfessionista 
                                                                key={'singolo_' + this.state.singolo}
                                                                value={ getProfessionistaValue(this.state.singolo) }
                                                                error={ this.state.singoloError }
                                                                callback={ this.updateSingolo }
                                                            />

                                                            <Input 
                                                                id='fatturato_precedente' name='fatturato_precedente' key='fatturato_precedente'
                                                                label='Fatturato anno precedente'
                                                                value={this.state.fatturato_precedente?.toString()}
                                                                type='number'
                                                                step='1'
                                                                min='0'
                                                                regexp={StringValidation.NUMBER_PATTERN}
                                                                errorDisplayMsg={'Valore non valido'}
                                                                callback={this.updateFatturato_precedente}
                                                                error={this.state.fatturato_precedenteError}
                                                            />

                                                            <Input 
                                                                id='fatturato_attuale' name='fatturato_attuale' key='fatturato_attuale'
                                                                label='Fatturato anno in corso'
                                                                value={this.state.fatturato_attuale?.toString()}
                                                                type='number'
                                                                step='1'
                                                                min='0'
                                                                regexp={StringValidation.NUMBER_PATTERN}
                                                                errorDisplayMsg={'Valore non valido'}
                                                                callback={this.updateFatturato_attuale}
                                                                error={this.state.fatturato_attualeError}
                                                            />
                                                        </>
                                                    }

                                                    { isMedico &&
                                                        <>
                                                            <Select
                                                                id='direzione_sanitaria' name='direzione_sanitaria' key='direzione_sanitaria'
                                                                label='Direzione Sanitaria' 
                                                                value={this.state.direzione_sanitaria}
                                                                options={this.state.tipo_direzione_sanitarie}
                                                                callback={this.updateDirezione_sanitaria}
                                                                error={this.state.direzione_sanitariaError}
                                                            />

                                                            <Select
                                                                id='regime_medico' name='regime_medico' key='regime_medico'
                                                                label='In quale regime operi?' 
                                                                value={this.state.regime_medico}
                                                                options={this.state.tipo_regime}
                                                                callback={this.updateRegime_medico}
                                                                error={this.state.regime_medicoError}
                                                            />

                                                            <Select
                                                                id='risarcimenti' name='risarcimenti' key='risarcimenti'
                                                                label={
                                                                    'Sono pervenute richieste di risarcimento per danni imputabili a ' + 
                                                                    'responsabilità professionale medica negli ultimi 5 anni?' 
                                                                }
                                                                value={this.state.risarcimenti}
                                                                options={this.state.tipo_risarcimenti}
                                                                callback={this.updateRisarcimenti}
                                                                error={this.state.risarcimentiError}
                                                            />
                                                        </>
                                                    }
                                                </>
                                            }

                                            { this.state.areaProfessionale !== undefined && this.state.tipo_retroattivita !== undefined &&
                                                <Select
                                                    id='retroattivita' name='retroattivita' key='retroattivita'
                                                    label='Periodo di retroattività' 
                                                    value={this.state.retroattivita}
                                                    options={this.state.tipo_retroattivita}
                                                    callback={this.updateRetroattivita}
                                                    error={this.state.retroattivitaError}
                                                />
                                            }

                                            <Select
                                                id='tipo_assicurazione' name='tipo_assicurazione' key='tipo_assicurazione'
                                                label='Specificare per cosa viene fatta la richiesta di preventivo' 
                                                value={this.state.tipo_assicurazione}
                                                options={this.state.tipo_assicurazioni}
                                                callback={this.updateTipo_assicurazione}
                                                error={this.state.tipo_assicurazioneError}
                                            />

                                            <Input 
                                                id='dettaglio_attivita' name='dettaglio_attivita' key='dettaglio_attivita'
                                                label='Dettaglio attività svolta' 
                                                value={this.state.dettaglio_attivita}
                                                type='text'
                                                maxLength={100}
                                                minLength={3}
                                                callback={this.updateDettaglio_attivita}
                                                regexp={this.isValidDettaglio_attivita}
                                                errorDisplayMsg='Valore non valido'
                                                remoteValidation={objectsNamesValidation}
                                                error={this.state.dettaglio_attivitaError}
                                            />

                                            <SiNo 
                                                id='rinnovo' name="rinnovo" key='rinnovo'
                                                label='Tacito Rinnovo?'
                                                value={ getSiNoValue( this.state.rinnovo ) }
                                                callback={this.updateRinnovo}
                                                error={this.state.rinnovoError}
                                            />

                                            { this.state.areaProfessionale !== undefined && this.state.tipo_massimali !== undefined &&
                                                <MultipleCheckbox
                                                    id='massimale'
                                                    label='Massimale (fino a)'
                                                    value={this.state.massimale}
                                                    options={this.state.tipo_massimali}
                                                    error={this.state.massimaleError}
                                                    callBack={this.updateMassimale}
                                                />
                                            }

                                            { this.state.tipo_assicurazione === 'rcProfessionale' &&
                                                <Select
                                                    id='altre_assicurazioni' name='altre_assicurazioni' 
                                                    key={'altre_assicurazioni_' + this.state.altre_assicurazioni}
                                                    label='Interesse altre assicurazioni' 
                                                    value={this.state.altre_assicurazioni}
                                                    options={this.state.tipo_altre_assicurazioni}
                                                    callback={this.updateAltre_assicurazioni}
                                                    error={this.state.altre_assicurazioniError}
                                                />
                                            }

                                            { (
                                                this.state.tipo_assicurazione !== 'tutelaLegale' && 
                                                (this.state.altre_assicurazioni === undefined || this.state.altre_assicurazioni === 'siRCPInfortuni') 
                                            ) &&
                                                <SiNo 
                                                    id='tutela_legale' name="tutela_legale" key='tutela_legale'
                                                    label='Tutela legale?'
                                                    value={ getSiNoValue( this.state.tutela_legale ) }
                                                    callback={this.updateTutela_legale}
                                                    error={this.state.tutela_legaleError}
                                                />
                                            }
                                            
                                        </div>

                                        <NoMotorPrivacy 
                                            id='noMotorPrivacy'
                                            basePrivacy={this.state.noMotorPrivacy}
                                            isLogged={this.state.user !== undefined}
                                            callback={this.updateNoMotorPrivacy}
                                            error={this.state.noMotorPrivacyError}
                                        />
                                    </SinglePage>

                                </Pagination>
                            </form>

                        </div>
                    </div>

                    <ModalWaith isOpen={this.state.waith}/>

                    <ModalNotification
                        title='Si è verificato un problema'
                        isError={erroOccours}
                        isOpen={erroOccours}
                        callBackToggle={ () => this.setState ({globalError: undefined}) }
                    >
                        {this.state.globalError}
                    </ModalNotification>

                    <ModalFinalQuestion 
                        isOpen={this.state.finalQuestIsOpen}
                        quoteRequestId={this.state.quoteRequestId}
                        callBackToggle={this.closeFinalQuestion}
                        expiredSessionCallbak={this.manageExpiredSessions}
                    />
                </article>
            </>
        )
    }

    // -- comuni
    getInitialState() {
        return profPageInitialState
    }
    
    getValidationError () : Promise<CompleteValidationError> {
        return Promise.all([
            this.step1ValidationNoProf(),
            this.step2Validation(),
        ])
        .then ((responses) => {
            let p: number | undefined = undefined
            let e: string | undefined  = undefined

            if (responses[0] !== undefined) {
                p = (responses[0] === 'PROFESSIONE') ? 2 : 1
                e = responses[0]
            }
            else if (responses[1] !== undefined) {
                p = 2
                e = responses[1]
            }

            return {
                errorString: e,
                pageError: p
            }
        })
        .catch (() => {
            return {
                errorString: CONNECTION_ERROR,
                pageError: undefined
            }
        })
    }

    printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) {
        const superErrors = super.printError(errorString, waith, pageError)

        if (superErrors?.globalError !== undefined) {
            this.setState( superErrors )
        }
        else {
            let areaErro = undefined
            let professioneErro = undefined
            let specializzazioneErro = undefined
            let massimaleErro = undefined
            let tutela_legaleErro = undefined
            let altre_assicurazioniErro = undefined
            let retroattivitaErro = undefined
            let tipo_assicurazioneErro = undefined
            let dettaglio_attivitaErro = undefined
            let rinnovoErro = undefined
            let regime_medicoErro = undefined
            let risarcimentiErro = undefined
            let direzione_sanitariaErro = undefined
            let attivita_chirurgicaErro = undefined
            let singoloErro = undefined
            let fatturato_precedenteErro = undefined
            let fatturato_attualeErro = undefined

            let noMotorPrivacyErro = undefined
            let global = undefined

            if (errorString === 'AREA_PROFESSIONALE') {
                areaErro = 'Valore non valido'
                global = "Indicare l'Area Professionale"
            }
            else if (errorString === 'PROFESSIONE') {
                professioneErro = 'Valore non valido'
                global = "Indicare la professione"
            }
            else if (errorString === 'SPECIALIZZAZIONE') {
                specializzazioneErro = 'Valore non valido'
                global = "Indicare la specializzazione"
            }
            else if (errorString === 'MASSIMALE') {
                massimaleErro = 'Valore non valido'
                global = "Selezionare il massimale "
            }
            else if (errorString === 'TUTELA_LEGALE') {
                tutela_legaleErro = 'Valore non valido'
                global = "Selezionare se si vuole avvalersi della tutela legale"
            }
            else if (errorString === 'ALTRE_ASSICURAZIONI') {
                altre_assicurazioniErro = 'Valore non valido'
                global = "Selezionare un valore per le altre assicurazioni "
            }
            else if (errorString === 'RETROATTIVITA') {
                retroattivitaErro = 'Valore non valido'
                global = "Indicare un periodo per la retroattività"
            }
            else if (errorString === 'TIPO_ASSICURAZIONE') {
                tipo_assicurazioneErro = 'Valore non valido'
                global = "Selezionare il tipo di assicurazione che si stà richiedendo"
            }
            else if (errorString === 'DETTAGLIO_ATTIVITA') {
                dettaglio_attivitaErro = 'Valore non valido'
                global = "Dettagliare l'attività svolta"
            }
            else if (errorString === 'RINNOVO') {
                rinnovoErro = 'Valore non valido'
                global = "Indicare se si desidera il rinnovo automatico"
            }
            else if (errorString === 'REGIME_MEDICO') {
                regime_medicoErro = 'Valore non valido'
                global = "Selezionare il regime in cui si opera"
            }
            else if (errorString === 'RISARCIMENTI') {
                risarcimentiErro = 'Valore non valido'
                global = "Indicare se esistono richieste di risarcimento"
            }
            else if (errorString === 'DIREZIONE_SANITARIA') {
                direzione_sanitariaErro = 'Valore non valido'
                global = "Selezionare un valore per la direzione sanitaria"
            }
            else if (errorString === 'ATTIVITA_CHIRURGICA') {
                attivita_chirurgicaErro = 'Valore non valido'
                global = "Indicare che tipo di attività chirurgica si esercita"
            }
            else if (errorString === 'SINGOLO') {
                singoloErro = 'Valore non valido'
                global = "Specificare se si esercita al interno di uno studio professionale"
            }
            else if (errorString === 'FATTURATO_PRECEDENTE') {
                fatturato_precedenteErro = 'Valore non valido'
                global = "Indicare il fatturato del anno precedente"
            }
            else if (errorString === 'FATTURATO_ATTUALE') {
                fatturato_attualeErro = 'Valore non valido'
                global = "Indicare il fatturato del anno in corso"
            }
            else if ( errorString === 'PRIVACY' ) {
                noMotorPrivacyErro = 'Selezionare i campi obbligatori'
                global = noMotorPrivacyErro
            } 
            else {
                global = errorString
            }

            this.setState ({
                waith: waith,
                actualPage: pageError ?? this.state.actualPage,

                areaProfessionaleError: areaErro,
                professioneError: professioneErro,
                specializzazioneError: specializzazioneErro,
                massimaleError: massimaleErro,
                tutela_legaleError: tutela_legaleErro,
                altre_assicurazioniError: altre_assicurazioniErro,
                retroattivitaError: retroattivitaErro,
                tipo_assicurazioneError: tipo_assicurazioneErro,
                dettaglio_attivitaError: dettaglio_attivitaErro,
                rinnovoError: rinnovoErro,
                regime_medicoError: regime_medicoErro,
                risarcimentiError: risarcimentiErro,
                direzione_sanitariaError: direzione_sanitariaErro,
                attivita_chirurgicaError: attivita_chirurgicaErro,
                singoloError: singoloErro,
                fatturato_precedenteError: fatturato_precedenteErro,
                fatturato_attualeError: fatturato_attualeErro,
                
                noMotorPrivacyError: noMotorPrivacyErro,
                globalError: global,
            })
        }
    }

    getSpecificDataForSubmit () {
        return {
            sinistriPrecedenti: this.state.altriSinistri ?? false,
            polizzaGiaAttiva: this.state.polizzaAttiva ?? false,
            dataScadenza: (this.state.polizzaAttiva === true) 
                ? (this.state.scadenzaPolizza ?? null)
                : null,

            rilevanza: this.getRilevanzaForSubmit(),

            // comuni
            area: this.state.areaProfessionale ? this.state.areaProfessionale : null,
            specializzazione: this.state.specializzazione ? this.state.specializzazione : null,
            massimale: this.state.massimale ? this.state.massimale : null,
            tutela_legale: this.state.tutela_legale !== undefined ? this.state.tutela_legale : null,
            altre_assicurazioni: this.state.altre_assicurazioni ? this.state.altre_assicurazioni : null,
            retroattivita: this.state.retroattivita ? this.state.retroattivita : null,
            tipoAssicurazione: this.state.tipo_assicurazione ? this.state.tipo_assicurazione : null,
            dettaglio_attivita: this.state.dettaglio_attivita ? this.state.dettaglio_attivita : null,
            rinnovo: this.state.rinnovo !== undefined ? this.state.rinnovo : null,

            // medici
            regime_medico: this.state.regime_medico ? this.state.regime_medico : null,
            risarcimenti: this.state.risarcimenti ? this.state.risarcimenti : null,
            direzione_sanitaria: this.state.direzione_sanitaria ? this.state.direzione_sanitaria : null,
            attivita_chirurgica: this.state.attivita_chirurgica ? this.state.attivita_chirurgica : null,

            // tecnici
            singolo: this.state.singolo !== undefined ? this.state.singolo : null,
            fatturato_precedente: this.state.fatturato_precedente ? this.state.fatturato_precedente : null,
            fatturato_attuale: this.state.fatturato_attuale ? this.state.fatturato_attuale : null,
        }
    }

    saveStateAndRedux (newState : object) {
        this.setState(
            newState, 
            () => {
                store.dispatch (
                    profUpdate (this.state)
                )
            }
        )
    }

    // specifici
    private updateTipo_area_professionale (val: any) {
        this.setState({
            tipo_area_professionale: val
        })
    }
    private updateTipo_area_giuridica (val: any) {
        this.setState({
            tipo_area_giuridica: val
        })
    }
    private updateTipo_area_medica (val: any) {
        this.setState({
            tipo_area_medica: val
        })
    }
    private updateTipo_area_tecnica (val: any) {
        this.setState({
            tipo_area_tecnica: val
        })
    }
    private updateTipo_direzione_sanitarie (val: any) {
        this.setState({
            tipo_direzione_sanitarie: val
        })
    }
    private updateTipo_massimali (val: any) {
        this.setState({
            tipo_massimali: val
        })
    }
    private updateTipo_regime (val: any) {
        this.setState({
            tipo_regime: val
        })
    }
    private updateTipo_retroattivita (val: any) {
        this.setState({
            tipo_retroattivita: val
        })
    }
    private updateTipo_risarcimenti (val: any) {
        this.setState({
            tipo_risarcimenti: val
        })
    }
    private updateTipo_assicurazioni (val: any) {
        this.setState({
            tipo_assicurazioni: val
        })
    }
    private updateTipo_professionisti (val: any) {
        this.setState({
            tipo_professionisti: val
        })
    }
    private updateTipo_altre_assicurazioni (val: any) {
        this.setState({
            tipo_altre_assicurazioni: val
        })
    }
    private updateTipo_attivita_chirurgica (val: any) {
        this.setState({
            tipo_attivita_chirurgica: val
        })
    }

    private updateAreaProfessionale (val: string | undefined) {
        Promise.all([
            this.getApChanges( val ),
            this.getApProfessions( val ),
            getMassimali ( val, this.updateTipo_massimali, this.manageExpiredSessions ),
            getRetroattivita ( val, this.updateTipo_retroattivita, this.manageExpiredSessions )
        ]).then ((responses) => {

            // response[O] --> info relative al area professionale
            const areaInfos = responses[0]

            const professionsInfos = {
                tipo_professioni: responses[1]?.professions ?? [],
            }

            let next : any = {
                ...areaInfos,
                ...professionsInfos,
                ...{
                    massimale: undefined,
                    retroattivita: undefined
                }
            }

            let pr : any = {
                professioneError: undefined,
                professione: undefined,
                contractor: {
                    ...this.state.contractor,
                    professione: undefined
                }
            }

            if (val === 'medica') {
                pr = {
                    professioneError: undefined,
                    professione: 'medico',
                    contractor: {
                        ...this.state.contractor,
                        professione: 'medico'
                    }
                }
            }

            next = {
                ...next,
                ...pr
            }

            this.saveStateAndRedux( next )
        })
    }

    private async getApChanges (val: string | undefined) : Promise<any> {
        const baseObj = {
            areaProfessionale: val,
            areaProfessionaleError: undefined,
            specializzazione: undefined,
            specializzazioneError: undefined,
            altre_assicurazioni: undefined,
            altre_assicurazioniError: undefined,
            // annullo la professione
            contractor: {
                ...this.state.contractor,
                professione: undefined
            }
        }
        const emptyMedico = {
            regime_medico: undefined,
            regime_medicoError: undefined,
            risarcimenti: undefined,
            risarcimentiError: undefined,
            direzione_sanitaria: undefined,
            direzione_sanitariaError: undefined,
            attivita_chirurgica: undefined,
            attivita_chirurgicaError: undefined,
        }
        const emptyProf = {
            singolo: undefined,
            singoloError: undefined,
            fatturato_precedente: undefined,
            fatturato_precedenteError: undefined,
            fatturato_attuale: undefined,
            fatturato_attualeError: undefined,
        }

        let newState : any = {}

        // se ha cambiato area -- > svuto tutto
        if (val === undefined || val !== this.state.specializzazione) {
            newState = {
                ...baseObj,
                ...emptyMedico,
                ...emptyProf
            }
        } 
        else if (val === 'medica') {
            newState = {
                ...baseObj,
                ...emptyProf
            }
        } 
        else if (val === 'giuridicoCommerciale' || val === 'tecnica') {
            newState = {
                ...baseObj,
                ...emptyMedico
            }
        }

        return Promise.resolve( newState )
    }
    private async getApProfessions (val: string | undefined) : Promise<any> {
        let next = { 
            professions: []
        }
        
        if (val === undefined) {
            return Promise.resolve( next )
        }
        else {
            return getProfessionByArea (
                val,
                this.manageExpiredSessions
            ).then ( (list : any) => {
                next.professions = list
                return next
            })
            .catch (() => {
                return next
            })
        }
    }

    private updateProfessione (val: string | undefined) {
        this.saveStateAndRedux({
            professione: val,
            professioneError: undefined,
            contractor: {
                ...this.state.contractor,
                professione: val
            }
        })
    }
    private clearContractorProfessionError () {
        if (this.state.user !== undefined && this.state.user.people !== undefined) {
            let peoples : any[] = [];

            // rimuovo tutti gli errori relativi alla professione!
            (this.state.user.people ?? []).forEach( (peo: any) => {
                let p = peo

                if (p.profession === undefined) {
                    const tmp = (p.errors ?? [])
                    const index = tmp.indexOf('Professione')
                    
                    if (index >= 0) {
                        tmp.splice(index, 1);  
                    }

                    p = {
                        ...p,
                        ...{ errors: tmp }
                    }
                    peoples.push( p )
                }   
            })

            if (peoples.length > 0) {
                let normalizedUser : UserType  = this.state.user

                // mergio i due array di persone
                const normalizedPeoples: Person[] = Array.from([...this.state.user.people, ...peoples]
                    .reduce((m, o) => m.set(o.id, o), new Map())
                    .values()
                );
                
                normalizedUser = {
                    ...normalizedUser,
                    ...{ people: normalizedPeoples }
                }

                this.saveStateAndRedux({
                    user: normalizedUser
                })
            }
        }
    }


    private updateSpecializzazione (val: string | undefined) {
        let newState = {
            specializzazione: val,
            specializzazioneError: undefined,
        }

        // se non è un chirurgo -- >  svuoto i campi relativi
        if (val !== 'medicoChirurgo') {
            newState = {
                ...newState,
                ...{
                    attivita_chirurgica: undefined,
                    attivita_chirurgicaError: undefined
                }
            }
        }
        
        
        this.saveStateAndRedux( newState )
    }
    private updateMassimale (val: string | undefined) {
        this.saveStateAndRedux({
            massimale: val,
            massimaleError: undefined,
        })
    }
    private updateTutela_legale (val: SiNoType) {
        const bVal = getBoolean(val)
        this.saveStateAndRedux({
            tutela_legale: bVal,
            tutela_legaleError: undefined,
        })
    }
    private updateAltre_assicurazioni (val: string | undefined) {
        let deducted_tutela = undefined

        if (
            val === 'siRCPTutela' ||
            val === 'siRCPTutelaInfortuni'
        ) {
            deducted_tutela = true
        }
        else if (val === 'noSoloRCP') {
            deducted_tutela = false
        }

        this.saveStateAndRedux({
            altre_assicurazioni: val,
            altre_assicurazioniError: undefined,
            tutela_legale: deducted_tutela,
            tutela_legaleError: undefined
        })
    }
    private updateRetroattivita (val: string | undefined) {
        this.saveStateAndRedux({
            retroattivita: val,
            retroattivitaError: undefined,
        })
    }
    private updateTipo_assicurazione (val: string | undefined) {
        const deducted_tutela = (val === 'tutelaLegale')

        this.saveStateAndRedux({
            tipo_assicurazione: val,
            tipo_assicurazioneError: undefined,
            tutela_legale: (deducted_tutela) ? true : this.state.tutela_legale,
            tutela_legaleError: (deducted_tutela) ? undefined : this.state.tutela_legaleError,
            altre_assicurazioni: undefined,
            altre_assicurazioniError: undefined,
        })
    }
    private updateDettaglio_attivita (val: string | undefined) {
        this.saveStateAndRedux({
            dettaglio_attivita: val,
            dettaglio_attivitaError: undefined,
        })
    }
    private updateRinnovo (val: SiNoType) {
        const bVal = getBoolean(val)
        this.saveStateAndRedux({
            rinnovo: bVal,
            rinnovoError: undefined,
        })
    }
    private updateRegime_medico (val: string | undefined) {
        this.saveStateAndRedux({
            regime_medico: val,
            regime_medicoError: undefined,
        })
    }
    private updateRisarcimenti (val: string | undefined) {
        this.saveStateAndRedux({
            risarcimenti: val,
            risarcimentiError: undefined,
        })
    }
    private updateDirezione_sanitaria (val: string | undefined) {
        this.saveStateAndRedux({
            direzione_sanitaria: val,
            direzione_sanitariaError: undefined,
        })
    }
    private updateAttivita_chirurgica (val: string | undefined) {
        this.saveStateAndRedux({
            attivita_chirurgica: val,
            attivita_chirurgicaError: undefined,
        })
    }
    private updateSingolo (val: boolean) {
        this.saveStateAndRedux({
            singolo: val,
            singoloError: undefined,
        })
    }
    private updateFatturato_precedente (val: number | undefined) {
        this.saveStateAndRedux({
            fatturato_precedente: val,
            fatturato_precedenteError: undefined,
        })
    }
    private updateFatturato_attuale (val: number | undefined) {
        this.saveStateAndRedux({
            fatturato_attuale: val,
            fatturato_attualeError: undefined,
        })
    }


    private isValidDettaglio_attivita () {
        return this.state.dettaglio_attivita === undefined || this.state.dettaglio_attivita.length >= 3
    }

    private async step1ValidationNoProf () {
        return this.step1Validation (
            true // ignoreProfession
        )
    }
    private async step2Validation () {
        const isMedico = (this.state.areaProfessionale === 'medica')
        const isChirurgo = (this.state.specializzazione === 'medicoChirurgo')
        const isTecnico = (this.state.areaProfessionale === 'tecnica' || this.state.areaProfessionale === 'giuridicoCommerciale')
        const isGenerica = (this.state.areaProfessionale === 'altraGenerica')

        let error = undefined

        if (this.state.altriSinistri === undefined) {
            error = 'SINISTRI'
        }
        else if (this.state.polizzaAttiva === undefined) {
            error = 'POLIZZA'
        }
        else if (
            this.state.polizzaAttiva === true && 
            isNotValidScadenzaPolizza(this.state.scadenzaPolizza)
        ) {
            error = 'SCADENZA_POLIZZA'
        }
        else if (this.state.areaProfessionale === undefined || this.state.areaProfessionale === 'Seleziona') {
            error = 'AREA_PROFESSIONALE'
        }
        else if ( StringValidation.isEmpty( this.state.professione )){
            error = 'PROFESSIONE'
        }

        else if (
            !isGenerica && 
            !isMedico &&
            (this.state.specializzazione === undefined  || this.state.specializzazione === 'Seleziona')
        ) {
            error = 'SPECIALIZZAZIONE'
        }

        else if (isMedico && (this.state.regime_medico === undefined || this.state.regime_medico === 'Seleziona')) {
            error = 'REGIME_MEDICO'
        }
        else if (isMedico && (this.state.risarcimenti === undefined || this.state.risarcimenti === 'Seleziona')) {
            error = 'RISARCIMENTI'
        }
        else if (isMedico && (this.state.direzione_sanitaria === undefined || this.state.direzione_sanitaria === 'Seleziona')) {
            error = 'DIREZIONESANITARIA'
        }
        else if (isMedico && isChirurgo && (this.state.attivita_chirurgica === undefined || this.state.attivita_chirurgica === 'Seleziona')) {
            error = 'ATTIVITA_CHIRURGICA'
        }

        else if ( isTecnico && this.state.singolo === undefined) {
            error = 'SINGOLO'
        }
        else if ( 
            isTecnico && 
            (this.state.fatturato_precedente === undefined || Number(this.state.fatturato_precedente) < 0)
        ) {
            error = 'FATTURATO_PRECEDENTE'
        }
        else if ( 
            isTecnico && 
            (this.state.fatturato_attuale === undefined || Number(this.state.fatturato_attuale) < 0)
        ) {
            error = 'FATTURATO_ATTUALE'
        }


        else if (this.state.retroattivita === undefined || this.state.retroattivita === 'Seleziona') {
            error = 'RETROATTIVITA'
        }
        else if (this.state.tipo_assicurazione === undefined || this.state.tipo_assicurazione === 'Seleziona') {
            error = 'TIPO_ASSICURAZIONE'
        }
        else if (
            this.state.dettaglio_attivita === undefined ||
            this.state.dettaglio_attivita.length < 3
        ) {
            error = 'DETTAGLIO_ATTIVITA'
        }
        else if (this.state.rinnovo === undefined) {
            error = 'RINNOVO'
        }
        else if (this.state.massimale === undefined || this.state.massimale === 'Seleziona') {
            error = 'MASSIMALE'
        }
        else if (
            this.state.tipo_assicurazione === 'rcProfessionale' && 
            (this.state.altre_assicurazioni === undefined || this.state.altre_assicurazioni === 'Seleziona')
        ) {
            error = 'ALTRE_ASSICURAZIONI'
        }
        else if (this.state.tutela_legale === undefined) {
            error = 'TUTELA_LEGALE'
        }
        

        else if (!isValidPrivacy(this.state.noMotorPrivacy, this.state.user !== undefined)) {
            error = 'PRIVACY'
        }
        else {
            await authFetch (
                STEP_2_VALIDATION_URL,
                {
                    method: "post",
                    body: JSON.stringify({
                        specificData: this.getSpecificDataForSubmit(),
                        professione: this.state.professione ?? null,
                        privacy: getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user),
                        isLogged: this.state.expiredSessionError === false ? this.state.user !== undefined : false
                    })
                },
                this.manageExpiredSessions,
            ).then ( jsonObj => {
                if (jsonObj.status > 200) {
                    error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
                }
            }).catch( error => {
                error = CONNECTION_ERROR
            })
        }

        this.printError(error)

        return error
    }

}

const mapState = (state: any) => {
  return {
    contractor: state.contractor,
    altriSinistri: state.altriSinistri,
    polizzaAttiva: state.polizzaAttiva,
    scadenzaPolizza: state.scadenzaPolizza,
    rilevanza: state.rilevanza,

    areaProfessionale: state.areaProfessionale,
    professione: state.professione,
    specializzazione: state.specializzazione,

    massimale: state.massimale,
    tutela_legale: state.tutela_legale,
    altre_assicurazioni: state.altre_assicurazioni,
    retroattivita: state.retroattivita,
    tipo_assicurazione: state.tipo_assicurazione,
    dettaglio_attivita: state.dettaglio_attivita,
    rinnovo: state.rinnovo,
    regime_medico: state.regime_medico,
    risarcimenti: state.risarcimenti,
    direzione_sanitaria: state.direzione_sanitaria,
    attivita_chirurgica: state.attivita_chirurgica,
    singolo: state.singolo,
    fatturato_precedente: state.fatturato_precedente,
    fatturato_attuale: state.fatturato_attuale,

    actualPage: state.actualPage,

    noMotorPrivacy: state.noMotorPrivacy,
    user: state.user
  }
}

export default connect(mapState) (ProfessionalPage)